var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinsInverted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.832V17.5C0 18.8789 3.35938 20 7.5 20C11.6406 20 15 18.8789 15 17.5V15.832C13.3867 16.9688 10.4375 17.5 7.5 17.5C4.5625 17.5 1.61328 16.9688 0 15.832ZM12.5 5C16.6406 5 20 3.87891 20 2.5C20 1.12109 16.6406 0 12.5 0C8.35938 0 5 1.12109 5 2.5C5 3.87891 8.35938 5 12.5 5ZM0 11.7344V13.75C0 15.1289 3.35938 16.25 7.5 16.25C11.6406 16.25 15 15.1289 15 13.75V11.7344C13.3867 13.0625 10.4336 13.75 7.5 13.75C4.56641 13.75 1.61328 13.0625 0 11.7344ZM16.25 12.1641C18.4883 11.7305 20 10.9258 20 10V8.33203C19.0938 8.97266 17.7617 9.41016 16.25 9.67969V12.1641ZM7.5 6.25C3.35938 6.25 0 7.64844 0 9.375C0 11.1016 3.35938 12.5 7.5 12.5C11.6406 12.5 15 11.1016 15 9.375C15 7.64844 11.6406 6.25 7.5 6.25ZM16.0664 8.44922C18.4102 8.02734 20 7.19922 20 6.25V4.58203C18.6133 5.5625 16.2305 6.08984 13.7227 6.21484C14.875 6.77344 15.7227 7.52344 16.0664 8.44922Z",
    fill: "#EA4160 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsInverted);
export default __webpack_public_path__ + "static/media/coins-inverted.0d6cbebd4423c639a730336fb1e17b61.svg";
export { ForwardRef as ReactComponent };